import { render, staticRenderFns } from "./SimpleVectorFilter.vue?vue&type=template&id=0b7a524e&scoped=true&"
import script from "./SimpleVectorFilter.vue?vue&type=script&lang=js&"
export * from "./SimpleVectorFilter.vue?vue&type=script&lang=js&"
import style0 from "./SimpleVectorFilter.vue?vue&type=style&index=0&id=0b7a524e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b7a524e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VCol,VContainer,VRow,VTextField})
